// @greenlight-spec: 11-observability.md#storage-and-tamper-evidence
// @greenlight-spec: 15-database-schema.md#orgs
import { z } from 'zod';
/**
 * The windows an org may keep its audit log for, in days. A short fixed menu
 * rather than a free number: an auditor reads "90 days" or "1 year", not 412.
 *
 * The floor is 90 days because other features read `audit_log` rows back that
 * far: the monthly cost rollup counts deploys up to 40 days back, and a shorter
 * window would delete them before the month closes. 2555 is seven years, the
 * longest common regulatory window.
 */
export const AUDIT_RETENTION_DAY_OPTIONS = [90, 180, 365, 730, 2555];
const RetentionDaysSchema = z
    .number()
    .int()
    .refine((n) => AUDIT_RETENTION_DAY_OPTIONS.includes(n), {
    message: `Must be one of ${AUDIT_RETENTION_DAY_OPTIONS.join(', ')} days.`,
});
/**
 * How long the org's audit log is kept. `null` keeps it indefinitely. A new org
 * starts at 90 days; orgs that predate the setting start at `null`.
 */
export const AuditRetentionSettingsSchema = z.object({
    retention_days: RetentionDaysSchema.nullable(),
});
export const UpdateAuditRetentionSettingsSchema = AuditRetentionSettingsSchema;
//# sourceMappingURL=audit-retention.js.map